import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './modules/core/pagenotfound/page-not-found.component';

// Self created guards
import { isAuthenticated } from './guards/guards';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./modules/authentication/authentication.module').then((m) => m.AuthenticationModule)
    },
    {
        path: 'calendar',
        loadChildren: () => import('./modules/calendar/calendar.module').then((m) => m.CalendarModule),
        canActivate: [isAuthenticated],
        data: { activeMenu: 'calendar' }
    },
    {
        path: 'contingent',
        loadChildren: () => import('./modules/contingent/contingent.module').then((m) => m.ContingentModule),
        canActivate: [isAuthenticated],
        data: { activeMenu: 'contingent' }
    },
    {
        path: 'usermanagement',
        loadChildren: () => import('./modules/user-management/user-management.module').then((m) => m.UserManagementModule),
        canActivate: [isAuthenticated],
        data: { activeMenu: 'usermanagement' }
    },
    { path: '', redirectTo: 'calendar', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
